module.exports = __webpack_public_path__ + "img/name.9b35a51a.png";